import { PillLabelDot } from 'common/pill-v2-label/pill-label-dot.js';
import { PillLabelV2 } from 'common/pill-v2-label/pill-label-v2.js';
import { PillDynamicWrapperV2 } from 'common/pill-v2/pill-dynamic-wrapper-v2.js';
import { MarkerDisplaySize } from 'types/location.js';
import { MarkerPillLabel } from 'types/markerTypesV2/m-v2-core.js';
import { IMarkerV2 } from 'types/markerTypesV2/m-v2-general.js';
import { predicateString } from 'utilities/isType.js';
import { FlexDivCenteredIcon } from 'utilities/svg-display/svg-layout.js';

export const MarkerLabelV2 = ({
  marker,
  selected,
  mockHover,
  markerDisplaySize,
  markerTextOverride,
  staticMarkerId,
}: {
  marker: IMarkerV2<MarkerPillLabel>;
  selected?: boolean;
  mockHover?: boolean;
  markerDisplaySize: MarkerDisplaySize;
  markerTextOverride?: string;
  staticMarkerId?: string;
}): JSX.Element => {
  const { position, action, label } = marker;
  const link = predicateString(action) ? action : undefined;
  return (
    <>
      <PillLabelDot />

      <PillDynamicWrapperV2
        displaySize={markerDisplaySize}
        selected={selected}
        mockHover={mockHover}
        staticPosition={position.staticPoint}
        labelPos={position.labelPos}
        markerType={marker.type}
        offset={position.offset}
        /**Only display dots as markers on pill type */
        isDot={false}
        textPos={position.textPos}
        staticMarkerId={staticMarkerId}
      >
        <PillLabelV2 labelText={markerTextOverride || label?.text} labelTextHover={label?.textHover}>
          {link && (
            <FlexDivCenteredIcon classes="u-pL-xs svg--fill-inherit" icon="chevron-right" color="white" size={14} />
          )}
        </PillLabelV2>
      </PillDynamicWrapperV2>
    </>
  );
};
